export const prefixesToDomainMap: Array<{ prefix: number, domain: string | undefined }> = [
    {
        prefix: 783,
        domain: 'interzet',
    },
    {
        prefix: 784,
        domain: 'interzet',
    },
    {
        prefix: 668,
        domain: 'ekat',
    },
    {
        prefix: 661,
        domain: 'ekat',
    },
    {
        prefix: 780,
        domain: 'interzet',
    },
    {
        prefix: 660,
        domain: 'ekat',
    },
    {
        prefix: 380,
        domain: 'irkutsk',
    },
    {
        prefix: 540,
        domain: 'nsk',
    },
    {
        prefix: 610,
        domain: 'rostov',
    },
    {
        prefix: 520,
        domain: 'nn',
    },
    {
        prefix: 550,
        domain: 'omsk',
    },
    {
        prefix: 162,
        domain: 'nk',
    },
    {
        prefix: 161,
        domain: 'chelny',
    },
    {
        prefix: 240,
        domain: 'krsk',
    },
    {
        prefix: 241,
        domain: 'krsk',
    },
    {
        prefix: 220,
        domain: 'barnaul',
    },
    {
        prefix: 221,
        domain: 'barnaul',
    },
    {
        prefix: 222,
        domain: 'barnaul',
    },
    {
        prefix: 420,
        domain: 'barnaul',
    },
    {
        prefix: 560,
        domain: 'oren',
    },
    {
        prefix: 174,
        domain: 'chel',
    },
    {
        prefix: 360,
        domain: 'voronezh',
    },
    {
        prefix: 640,
        domain: 'saratov',
    },
    {
        prefix: 580,
        domain: 'penza',
    },
    {
        prefix: 180,
        domain: 'izhevsk',
    },
    {
        prefix: 274,
        domain: 'mgn',
    },
    {
        prefix: 450,
        domain: 'kurgan',
    },
    {
        prefix: 102,
        domain: 'ufa',
    },
    {
        prefix: 710,
        domain: 'tula',
    },
    {
        prefix: 730,
        domain: 'ulsk',
    },
    {
        prefix: 620,
        domain: 'ryazan',
    },
    {
        prefix: 210,
        domain: 'cheb',
    },
    {
        prefix: 320,
        domain: 'bryansk',
    },
    {
        prefix: 322,
        domain: 'bryansk',
    },
    {
        prefix: 160,
        domain: 'kazan',
    },
    {
        prefix: 690,
        domain: 'tver',
    },
    {
        prefix: 460,
        domain: 'kursk',
    },
    {
        prefix: 120,
        domain: 'yola',
    },
    {
        prefix: 760,
        domain: 'yar',
    },
    {
        prefix: 480,
        domain: 'lipetsk',
    },
    {
        prefix: 481,
        domain: 'lipetsk',
    },
    {
        prefix: 482,
        domain: 'lipetsk',
    },
    {
        prefix: 430,
        domain: 'kirov',
    },
    {
        prefix: 700,
        domain: 'tomsk',
    },
    {
        prefix: 701,
        domain: 'tomsk',
    },
    {
        prefix: 720,
        domain: 'tmn',
    },
    {
        prefix: 348,
        domain: 'vlz',
    },
    {
        prefix: 340,
        domain: 'volgograd',
    },
    {
        prefix: 342,
        domain: 'volgograd',
    },
    {
        prefix: 630,
        domain: 'samara',
    },
    {
        prefix: 590,
        domain: 'perm',
    },
    {
        prefix: 781,
        domain: 'interzet',
    },
    {
        prefix: 381,
        domain: 'irkutsk',
    },
    {
        prefix: 384,
        domain: 'irkutsk',
    },
    {
        prefix: 782,
        domain: 'interzet',
    },
    {
        prefix: 785,
        domain: 'interzet',
    },
    {
        prefix: 970,
        domain: undefined,
    },
    {
        prefix: 761,
        domain: 'yar',
    },
    {
        prefix: 100,
        domain: undefined,
    },
    {
        prefix: 382,
        domain: 'irkutsk',
    },
    {
        prefix: 383,
        domain: 'irkutsk',
    },
    {
        prefix: 621,
        domain: undefined,
    },
    {
        prefix: 622,
        domain: undefined,
    },
    {
        prefix: 591,
        domain: 'perm',
    },
    {
        prefix: 341,
        domain: 'volgograd',
    },
    {
        prefix: 770,
        domain: 'msk',
    },
    {
        prefix: 771,
        domain: 'msk',
    },
    {
        prefix: 772,
        domain: 'msk',
    },
    {
        prefix: 773,
        domain: 'msk',
    },
    {
        prefix: 775,
        domain: 'msk',
    },
    {
        prefix: 230,
        domain: 'krd',
    },
    {
        prefix: 300,
        domain: 'ulu',
    },
    {
        prefix: 301,
        domain: 'ulu',
    },
    {
        prefix: 303,
        domain: 'ulu',
    },
];
